import { useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import FoundingOffer from "../components/FoundingOffer";
import WhatWeCheck from "../components/WhatWeCheck";
import HowItWorksTender from "../components/HowItWorksTender";
import WhoItsFor from "../components/WhoItsFor";
import WhyBlackline from "../components/WhyBlackline";
import Packages from "../components/Packages";
import FAQ from "../components/FAQ";
import RelatedService from "../components/RelatedService";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import { usePageMeta } from "../hooks/usePageMeta";

export default function LandingPage() {
  usePageMeta("home");
  const [showForm, setShowForm] = useState(false);

  const scrollToForm = () => {
    const formSection = document.getElementById("contact");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToPackages = () => {
    const packagesSection = document.getElementById("packages");
    if (packagesSection) {
      packagesSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onContactClick={scrollToForm} />
      <main>
        <Hero onUploadClick={scrollToForm} onPackagesClick={scrollToPackages} />
        <FoundingOffer />
        <WhatWeCheck />
        <HowItWorksTender />
        <WhoItsFor />
        <WhyBlackline />
        <Packages onGetStarted={scrollToForm} />
        <FAQ />
        <RelatedService />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
